import FormikHomeAssumptionsZurichLandlordPage from './FormikHomeAssumptionsZurichLandlordPage';

export default FormikHomeAssumptionsZurichLandlordPage;
